document.addEventListener("DOMContentLoaded", function () {
    const panels = document.querySelectorAll(".faq .panel");

    panels.forEach((panel) => {
        const header = panel.querySelector(".faq .panel-header");
        const content = panel.querySelector(".faq .panel-content");
        const toggleIcon = panel.querySelector(".faq .toggle-icon");

        header.addEventListener("click", function () {
            panel.classList.toggle("active");
            if (panel.classList.contains("active")) {
                content.style.maxHeight = content.scrollHeight + "px";
                toggleIcon.textContent = "-";
            } else {
                content.style.maxHeight = "0";
                toggleIcon.textContent = "+";
            }
        });
    });
});
$(document).ready(function () {
      // Hide all divs
    $(".fq").addClass("hidden");
    $("#general").addClass("active");
    // Show the div with the matching class (class starting with 'div' + clickedId)
    $(".general").removeClass("hidden");
    $(".faq-side-nav li").click(function () {
      
        // Remove the "active" class from all <li> elements
        $(".faq-side-nav li").removeClass("active");

        // Add the "active" class to the clicked <li>
        $(this).addClass("active");
      
        // Get the ID of the clicked li
        var clickedId = $(this).attr("id");

        // Hide all divs
        $(".fq").addClass("hidden");

        // Show the div with the matching class (class starting with 'div' + clickedId)
        $("." + clickedId).removeClass("hidden");
    });
});
